var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.31 45.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.75,1.57c-1.04-1.04-2.35-1.57-3.9-1.57H5.47c-1.55,0-2.86.53-3.9,1.57S0,3.92,0,5.47v34.55c0,1.55.53,2.86,1.57,3.9,1.04,1.04,2.35,1.57,3.9,1.57h47.38c1.55,0,2.86-.53,3.9-1.57,1.04-1.04,1.57-2.35,1.57-3.9V5.47c0-1.55-.53-2.86-1.57-3.9ZM29.16,19.19L5.43,3.77h47.44l-23.72,15.42ZM4.25,41.23c-.32-.32-.47-.72-.47-1.22V6.85l25.38,16.6L54.54,6.85v33.16c0,.5-.15.9-.47,1.22s-.72.47-1.22.47H5.47c-.5,0-.9-.15-1.22-.47Z",
    fill: "#164679"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.8b7bddc510297cee3eb828a0842aefe3.svg";
export { ForwardRef as ReactComponent };